import axios, { AxiosResponse } from "axios";
import { snackbarRef } from "providers/NotistackProvider";
import networkState from "states/networkState";

const call = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  transformResponse: (data, headers) => {
    data = data
      .replaceAll("vectr-user-images-staging", "vectr-user-images-production")
      .replaceAll(".ap-southeast-1", "");

    if (headers["content-type"].includes("application/json")) {
      return JSON.parse(data);
    }

    return data;
  },
});

call.interceptors.request.use(
  (config) => {
    networkState.calling.set((s) => s + 1);

    if (config.headers.Authorization === false) {
      delete config.headers.Authorization;
    } else {
      const access_token = localStorage.getItem("access_token");

      if (access_token) {
        config.headers.Authorization = `Bearer ${access_token}`;
      }
    }

    return config;
  },
  (error) => {
    networkState.calling.set((s) => (s > 0 ? s - 1 : 0));

    return Promise.reject(error);
  }
);

call.interceptors.response.use(
  (response) => {
    networkState.calling.set((s) => (s > 0 ? s - 1 : 0));

    return response;
  },
  (error) => {
    networkState.calling.set((s) => (s > 0 ? s - 1 : 0));

    const response: AxiosResponse = error.response;

    if (response?.status === 413) {
      snackbarRef.current?.enqueueSnackbar(
        "Your file is too large for the system; changes you made may not be saved.",
        {
          variant: "error",
        }
      );
    }

    return Promise.reject(error);
  }
);

export default call;
